export default {
  id: 'l-8',
  navTitleID: 'l-6.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-2',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-3',
      components: [
        {
          type: 'popup',
          styling: {
            textAlign: 'center'
          },
          popups: [
            {
              textID: 'popup1text',
              popupHeaderId: 'popup1',
              labelID: 'popup1',
              icon: 'baby-carriage',
              width: '50rem'
            },
            {
              textID: 'popup2text',
              popupHeaderId: 'popup2',
              labelID: 'popup2',
              icon: 'taxi',
              width: '50rem'
            },
            {
              textID: 'popup3text',
              popupHeaderId: 'popup3',
              labelID: 'popup3',
              icon: 'cooking-chef-cap',
              width: '50rem'
            }
          ]
        },
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-4',
      components: [
        {
          type: 'popup',
          styling: {
            textAlign: 'center'
          },
          popups: [
            {
              textID: 'popuptext',
              popupHeaderId: 'popup',
              labelID: 'popup',
              icon: 'baby-carriage',
              width: '50rem'
            }
          ]
        },
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          rightFeedbackID: 'feedback-right',
          wrongFeedbackID: 'feedback-wrong',
          options: [
            {
              isCorrect: true,
              textID: 'option-1'
            },
            {
              isCorrect: false,
              textID: 'option-2'
            },
            {
              isCorrect: false,
              textID: 'option-3'
            },
            {
              isCorrect: true,
              textID: 'option-4'
            }
          ]
        }
      ]
    },
    {
      id: 'page-5',
      components: [
        {
          type: 'popup',
          styling: {
            textAlign: 'center'
          },
          popups: [
            {
              textID: 'popuptext',
              popupHeaderId: 'popup',
              labelID: 'popup',
              icon: 'taxi',
              width: '50rem'
            }
          ]
        },
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          rightFeedbackID: 'feedback-right',
          wrongFeedbackID: 'feedback-wrong',
          options: [
            {
              isCorrect: false,
              textID: 'option-1'
            },
            {
              isCorrect: true,
              textID: 'option-2'
            },
            {
              isCorrect: true,
              textID: 'option-3'
            },
            {
              isCorrect: false,
              textID: 'option-4'
            }
          ]
        }
      ]
    },
    {
      id: 'page-6',
      components: [
        {
          type: 'popup',
          styling: {
            textAlign: 'center'
          },
          popups: [
            {
              textID: 'popuptext',
              popupHeaderId: 'popup',
              labelID: 'popup',
              icon: 'cooking-chef-cap',
              width: '50rem'
            }
          ]
        },
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          rightFeedbackID: 'feedback-right',
          wrongFeedbackID: 'feedback-wrong',
          options: [
            {
              isCorrect: true,
              textID: 'option-1'
            },
            {
              isCorrect: true,
              textID: 'option-2'
            },
            {
              isCorrect: false,
              textID: 'option-3'
            },
            {
              isCorrect: false,
              textID: 'option-4'
            }
          ]
        }
      ]
    },
    {
      id: 'page-7',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'empty',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text3'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text4'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text5'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text6'
            }
          ]
        }
      ]
    }
  ]
}
